import React, { useEffect } from 'react';
import {
  List,
  Datagrid,
  TextField,
  FunctionField
} from 'react-admin';

function PodcastList(props: any) {
  useEffect(() => {
    document.title = 'Listado de Podcasts';
  }, []);

  return (
    <List {...props}>
      <Datagrid>
        <FunctionField
          source="portada"
          render={(record: any) => (
            <img
              src={record.portada.url}
              alt={record.portada.alternativeText}
              style={{ width: '120px', height: 'auto' }}
            />
          )}
        />
        <TextField source="titulo" />
        <TextField source="fecha" />
        <TextField source="autor" />
      </Datagrid>
    </List>
  )
}

export default PodcastList;